'use client';

import { Cms } from '@bytel/product-wall';
import {
    Align,
    DirectionEnum,
    FlexBox,
    FlexItem,
    GapSize,
    Justify,
    Text,
    TextLevels,
    TypographyAlign,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';
import { PromoHomeSticker } from '@components/promo-home-sticker';

import { capitalize, formatPrice } from '@helpers/wording';

interface TicketLineProps {
    title: string;
    basePrice: number;
    price: number;
    priceDuration?: number;
    period?: string;
    obligationLabel?: string;
    promoAmount?: number;
    isBold?: boolean;
    isLoading?: boolean;
}

export function TicketLine({
    title,
    price,
    basePrice,
    promoAmount,
    priceDuration,
    period,
    obligationLabel,
    isBold = true,
    isLoading = true,
    ...props
}: Readonly<TicketLineProps>) {
    return (
        <FlexItem {...props}>
            <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.TWO}>
                <FlexItem>
                    <FlexBox
                        justify={Justify.SPACE_BETWEEN}
                        align={Align.START}
                        gap={GapSize.TWO}
                        direction={DirectionEnum.ROW}
                    >
                        <FlexItem>
                            <Text
                                marginless
                                level={TextLevels.ONE}
                                typo={[isBold ? TypographyBold.TEXT_WEIGHT_SEMIBOLD : '', TypographyAlign.TEXT_LEFT]}
                            >
                                <Cms as='span' content={title} />
                            </Text>
                            {priceDuration && priceDuration > 0 ? (
                                <Text marginless level={TextLevels.THREE}>
                                    {`Pendant ${priceDuration} mois puis ${formatPrice(basePrice)}/mois`}
                                </Text>
                            ) : null}
                            {obligationLabel && (
                                // div is used for skeleton loading, don't remove it
                                <div>
                                    <Text marginless level={TextLevels.THREE}>
                                        {capitalize(obligationLabel)}
                                    </Text>
                                </div>
                            )}
                        </FlexItem>
                        <InlinePrice level={TextLevels.ONE} amount={price} period={period} />
                    </FlexBox>
                </FlexItem>
                {!isLoading && promoAmount ? (
                    <FlexItem>
                        <PromoHomeSticker
                            text={
                                <>
                                    Vos économies&nbsp;:{' '}
                                    <InlinePrice amount={promoAmount} period='mois' level={TextLevels.TWO} />
                                </>
                            }
                        />
                    </FlexItem>
                ) : null}
            </FlexBox>
        </FlexItem>
    );
}
